<template>
  <div id="container" style="    width: 100%;">
    <a-form :model="editState" ref="formRef" :rules="rules">
      <a-form-item :name="item.type" :label="item.title" v-for="item, index in fapiaoInput" v-bind:key="index">
        <template v-if="item.title == '名称'">
          <a-auto-complete v-model:value="editState.title" placeholder="必填" :options="dataSource" @search="toSearch"
            @select="onSelect">
            <template #option="item">
              <div>
                <template v-for="itemItem in item.searchName">
                  <span v-if="itemItem.key == true" style='color:red'>{{ itemItem.str }}</span>
                  <span v-else>{{ itemItem.str }}</span>
                </template>
              </div>
            </template>
          </a-auto-complete>
        </template>
        <a-input v-else v-model:value="editState[item.type]" :placeholder="item.placeholder">
        </a-input>
      </a-form-item>
    </a-form>
    <div style="    text-align: center;">
      <a-button type="primary" @click="toSubmit">确定</a-button>
    </div>
  </div>
  <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
     <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
  </a-modal>-->
</template>
<script>
import { hilight_str } from '../../untils/index'
import { reactive, watch, onMounted, ref } from 'vue'
import { getSearchMind, postSetClientInvoice, getCompanyTaxNo, getClientInvoiceList } from './js'
import store from '@/store'
import { message } from 'ant-design-vue/lib/components'
export default {
  name: 'ticketPage',
  setup() {
    watch(() => store.getters.company, (val) => {
      if (val && val != '') {
        var height = document.getElementById('container').offsetHeight
        scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
      }
    })
    onMounted(() => {
      var height = document.getElementById('container').offsetHeight
      scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
      getClientInvoiceList().then(res => {
        if (res.data && res.data.title) {
          editState.id = res.data.id
          for (var i in editState) {
            editState[i] = res.data[i]
          }
        }
        else {
          for (var i in editState) {
            editState[i] = ""
          }
          editState.id = null
        }
      })
    })
    const scrollView = ref('')
    const scrollY = ref(0)
    const editState = reactive({
      id: null,
      title: '',
      taxNo: '',
      mail: '',
      mobile: '',
      companyAdd: '',
      companyPhone: '',
      bankName: '',
      bankAccount: ''
    })
    const formRef = ref(null)
    const rules = {
      title: [
        { required: true, message: '必填', trigger: 'blur' },
      ],
      taxNo: [
        { required: true, message: '必填', trigger: 'blur' },
      ],
      mail: [
        { required: true, message: '必填', trigger: 'blur' },
      ],
    };
    const searchList = ref([])
    const handleChange = () => {
    }
    const dataSource = ref([])
    const toSearch = () => {
      editState.title = editState.title.trim()
      if (editState.title.length > 1) {
        if (timmer.value)
          clearTimeout(timmer.value)
        timmer.value = setTimeout(() => {
          getSearchMind({ name: editState.title }).then((res) => {
            var list = []
            for (var i in res.data) {
              var name = res.data[i].Name.replace(/<\/?(?:em)[^>]*>/g, '')
              var data = hilight_str(editState.title, name);
              list.push({ value: name, name: name, searchName: data, keyNo: res.data[i].KeyNo })
            }
            dataSource.value = list
          })
        }, 500)
      }
      else {
        dataSource.value = []
      }
    }
    const timmer = ref(null)
    const toSubmit = () => {
      formRef.value
        .validate()
        .then(() => {
          postSetClientInvoice(editState).then((res) => {
            message.success('保存成功')
          })
        })
    }
    const onSelect = (value) => {
      var result = dataSource.value.find(item => item.value == value)
      if (result) {
        getCompanyTaxNo({ keyNo: result.keyNo }).then((res) => {
          if (res.data)
            editState.taxNo = res.data.CreditCode
          else { editState.taxNo = "" }
        })
      }
    }
    return {
      onSelect,
      toSubmit,
      dataSource,
      timmer,
      toSearch,
      handleChange,
      searchList,
      rules,
      formRef,
      editState,
      fapiaoInput: [{ title: '名称', placeholder: '必填', type: 'title' },
      { title: '税号', placeholder: '必填', type: 'taxNo' },
      { title: '邮箱', placeholder: '必填', placeholder1: '必填', type: 'mail' },
      { title: '手机号码', placeholder: '选填', placeholder1: '必填', type: 'mobile' },
      { title: '单位地址', placeholder: '选填', placeholder1: '必填', type: 'companyAdd' },
      { title: '电话号码', placeholder: '选填', placeholder1: '必填', type: 'companyPhone' },
      { title: '开户银行', placeholder: '选填', placeholder1: '必填', type: 'bankName' },
      { title: '银行账户', placeholder: '选填', placeholder1: '必填', type: 'bankAccount' },
      ],
      scrollY,
      scrollView,
    }
  },
}
</script>
<style>
.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  padding: 8px 8px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tablestyle {
  margin-top: 20px;
}

.scrollView {
  margin: 10px 0px;
}

.datelist {
  margin-left: 10px;
  display: inline-block;
}

.datelist a {
  margin-right: 10px;
}
</style>